<template>
    <div id="spin">
        <a-spin :tip="`正在加载`"
                size="large"
                v-if="isShow"
                :indicator="indicator" />
    </div>
</template>
 
<script>
export default {
    data() {
        return {
            isShow: true,
            indicator: <a-icon type="loading" style="font-size: 24px" spin />
        }
    }
};
</script>
<style>
</style>